<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-if="showMode==='list'">
            <div class="model-container">
                <div :class="activeItem==='1'?'model-item model-active':'model-item'" @click="handleActiveChange('1')">主课题管理</div>
                <div :class="activeItem==='2'?'model-item model-active':'model-item'" @click="handleActiveChange('2')">子课题管理</div>
                <div :class="activeItem==='3'?'model-item model-active':'model-item'" @click="handleActiveChange('3')">子课题审核</div>
                <div :class="activeItem==='4'?'model-item model-active':'model-item'" @click="handleActiveChange('4')">资料审核</div>
            </div>
            <!--主课题管理-->
            <div class="bre9e" v-show="activeItem==='1'">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 232px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="90" align="center" label="课题状态" prop="status">
                        <template #default="scope">
                            <div v-if="scope.row.status === 0">初始</div>
                            <div v-if="scope.row.status === 1">进行中</div>
                            <div v-if="scope.row.status === 2">已结束</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="250" align="center" label="课题名称" prop="topicName">
                        <template #default="scope">
                            <div :title="scope.row.topicName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.topicName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="课题级别" prop="topicLevel">
                        <template #default="scope">
                            <div v-if="scope.row.topicLevel === '1'">国家级课题</div>
                            <div v-if="scope.row.topicLevel === '2'">省级课题</div>
                            <div v-if="scope.row.topicLevel === '3'">市级课题</div>
                            <div v-if="scope.row.topicLevel === '4'">区县课题</div>
                            <div v-if="scope.row.topicLevel === '5'">学校课题</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="课题方向" prop="topicClassifyName">
                    </el-table-column>
                    <el-table-column width="200" align="center" label="课题单位" prop="orgNames">
                    </el-table-column>
                    <el-table-column width="135" align="center" label="课题负责人" prop="leaderNames">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" min-width="160">
                        <template #default="scope">
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       size="small"
                                       v-if="scope.row.status===2&&scope.row.isRelease===0"
                                       @click="handleRelease(scope.row)">发布</el-button>
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       size="small"
                                       v-if="scope.row.isRelease===1"
                                       @click="handleRelease(scope.row)">发布编辑</el-button>
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       size="small"
                                       @click="handleManager(scope.row)">管理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 子课题管理 -->
            <div class="bre9e" v-show="activeItem==='2'">
                <el-table header-cell-class-name="bgf2"
                          show-overflow-tooltip
                          height="calc(100vh - 232px)"
                          :data="managerSubTopicList"
                          highlight-current-row>
                    <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                    <el-table-column width="200" align="center" label="子课题名称" prop="topicName">
                        <template #default="scope">
                            <div :title="scope.row.topicName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.topicName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="90" align="center" label="课题状态" prop="status">
                        <template #default="scope">
                            <div v-if="scope.row.status===1">报名阶段</div>
                            <div v-if="scope.row.status===2">开题阶段</div>
                            <div v-if="scope.row.status===3">中期检查</div>
                            <div v-if="scope.row.status===4">结题验收</div>
                            <div v-if="scope.row.status===5">课题结束</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="教师姓名" prop="leaderNames">
                    </el-table-column>
                    <el-table-column width="160" align="center" label="所属单位" prop="orgName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="学段学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="最高学历" prop="qualificationName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="技术职称" prop="rankLevelName">
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="审核专家" prop="checkUserName">
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="审核状态" prop="isCheck">
                        <template #default="scope">
                            <div v-if="scope.row.isCheck===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.isCheck===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.isCheck===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.isCheck===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="160" label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       size="small"
                                       v-if="scope.row.status===5&&scope.row.isRelease===0"
                                       @click="handleSubRelease(scope.row)">发布</el-button>
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       size="small"
                                       v-if="scope.row.isRelease===1"
                                       @click="handleSubRelease(scope.row)">发布编辑</el-button>
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       size="small"
                                       @click="subTopicManager(scope.row)">管理</el-button>

                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 子课题审核 -->
            <div class="bre9e" v-show="activeItem==='3'">
                <el-table header-cell-class-name="bgf2"
                          show-overflow-tooltip
                          height="calc(100vh - 232px)"
                          :data="subTopicList"
                          highlight-current-row>
                    <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                    <el-table-column width="130" align="center" label="报名时间" prop="status">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.createTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="子课题名称" prop="topicName">
                        <template #default="scope">
                            <div :title="scope.row.topicName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.topicName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="教师姓名" prop="leaderNames">
                    </el-table-column>
                    <el-table-column width="200" align="center" label="所属单位" prop="orgName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="学段学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="最高学历" prop="qualificationName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="技术职称" prop="rankLevelName">
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="审核专家" prop="checkUserName">
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="审核状态" prop="isCheck">
                        <template #default="scope">
                            <div v-if="scope.row.isCheck===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.isCheck===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.isCheck===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.isCheck===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-button v-if="scope.row.isCheck===2" type="primary" style="background-color: #3b82f6;color: #fff" size="small" @click="topicCheck(scope.row)">审核</el-button>
                            <el-button v-if="scope.row.isCheck!==2" type="primary" size="small" @click="topicCheck(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--报名审核-->
            <div class="bre9e mt5" v-show="activeItem==='4'">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 232px)"
                          :data="signList"
                          highlight-current-row>
                    <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                    <el-table-column width="90" align="center" label="所属状态" prop="status">
                        <template #default="scope">
                            <div v-if="scope.row.status === 1">报名阶段</div>
                            <div v-if="scope.row.status === 2">开题论证</div>
                            <div v-if="scope.row.status === 3">中期检查</div>
                            <div v-if="scope.row.status === 4">结题验收</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="资料提交时间" width="130" prop="">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.submitTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="子课题名称" prop="topicName">
                        <template #default="scope">
                            <div :title="scope.row.topicName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.topicName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="教师姓名" width="80" prop="trueName"/>
                    <el-table-column width="100" align="center" label="学段学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="160" align="center" label="所属单位" prop="orgName">
                    </el-table-column>
                    <el-table-column width="80" align="center" label="最高学历" prop="qualificationName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="技术职称" prop="rankLevelName">
                    </el-table-column>
                    <!-- 申报阶段 -->
                    <el-table-column width="80" fixed="right" align="center" label="审核专家" prop="sbCheckUserName">
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.status===1&&scope.row.sbStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.status===1&&scope.row.sbStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.status===1&&scope.row.sbStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.status===1&&scope.row.sbStatus===4" class="tab-shjj">拒绝</div>

                            <div v-if="scope.row.status===2&&scope.row.ktStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.status===2&&scope.row.ktStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.status===2&&scope.row.ktStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.status===2&&scope.row.ktStatus===4" class="tab-shjj">拒绝</div>

                            <div v-if="scope.row.status===3&&scope.row.zqStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.status===3&&scope.row.zqStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.status===3&&scope.row.zqStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.status===3&&scope.row.zqStatus===4" class="tab-shjj">拒绝</div>

                            <div v-if="scope.row.status===4&&scope.row.jtStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.status===4&&scope.row.jtStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.status===4&&scope.row.jtStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.status===4&&scope.row.jtStatus===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" width="100" label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-button type="primary" size="small"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 1&&(scope.row.sbStatus===3||scope.row.sbStatus===4)">
                                查看
                            </el-button>
                            <el-button type="primary" size="small"
                                       style="background-color: #3b82f6;color: #fff"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 1&&scope.row.sbStatus===2">
                                审核
                            </el-button>

                            <el-button type="primary" size="small"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 2&&(scope.row.ktStatus===3||scope.row.ktStatus===4)">
                                查看
                            </el-button>
                            <el-button type="primary" size="small"
                                       style="background-color: #3b82f6;color: #fff"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 2&&scope.row.ktStatus===2">
                                审核
                            </el-button>

                            <el-button type="primary" size="small"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 3&&(scope.row.zqStatus===3||scope.row.zqStatus===4)">
                                查看
                            </el-button>
                            <el-button type="primary" size="small"
                                       style="background-color: #3b82f6;color: #fff"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 3&&scope.row.zqStatus===2">
                                审核
                            </el-button>

                            <el-button type="primary" size="small"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 4&&(scope.row.jtStatus===3||scope.row.jtStatus===4)">
                                查看
                            </el-button>
                            <el-button type="primary" size="small"
                                       style="background-color: #3b82f6;color: #fff"
                                       @click="signCheck(scope.row)"
                                       v-if="scope.row.status === 4&&scope.row.jtStatus===2">
                                审核
                            </el-button>


                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--课题管理-->
        <div class="detail-mode" v-if="showMode==='manager'">
            <topic-manager-info :topic-id="topicId"/>
        </div>
        <!-- 子课题管理 -->
        <div class="detail-mode" v-if="showMode==='submanager'">
            <home-sub-topic-manager :sub-topic-id="subTopicId" @change-active-mode="changeActiveModel"/>
        </div>
        <!-- 子课题审核查看 -->
        <div class="detail-mode" v-if="showMode==='subtopic'">
            <sub-topic-check :sub-topic-id="subTopicId" @change-active-mode="changeActiveModel"/>
        </div>

        <!-- 报名审核 -->
        <div class="detail-mode" v-if="showMode==='signCheck'">
            <topic-sign-check :info-id="signId" :info-status="signStatus"
                              @change-active-mode="changeActiveModel"/>
        </div>

        <!-- 主课题发布 -->
        <div class="detail-mode" v-if="showMode==='release'">
            <topic-release :info-id="topicId"
                              @change-active-mode="changeActiveModel"/>
        </div>

        <!-- 子课题发布 -->
        <div class="detail-mode" v-if="showMode==='subRelease'">
            <sub-topic-release :info-id="topicId"
                           @change-active-mode="changeActiveModel"/>
        </div>

    </div>
</template>

<script>
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import {listUserManagerTopic} from  "@/api/admin/topic"
import {userCheckList,userManagerList} from  "@/api/admin/lead"
import {userCheckSignList} from  "@/api/admin/topicSign"

import topicManagerInfo from "@/components/homeManager/topicManagerInfo.vue";
import subTopicCheck from "@/components/homeManager/subTopicCheck.vue";
import topicManager from "@/views/topic/topicManager.vue";
import homeSubTopicManager from "@/components/homeManager/homeSubTopicManager.vue";
import topicSignCheck from "@/components/homeManager/topicSignCheck.vue";
import topicRelease from "@/components/homeManager/topicRelease.vue";
import subTopicRelease from "@/components/homeManager/subTopicRelease.vue";

export default {
    name:'topicManager',
    computed: {},
    components:{
        topicManagerInfo,
        subTopicCheck,
        topicManager,
        homeSubTopicManager,
        topicSignCheck,
        topicRelease,
        subTopicRelease
    },
    props:{
        itemMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        itemMode(newValue,oldValue){
            this.showMode = newValue;
            this.listTopic()
        },
    },
    mounted() {
        this.listTopic()
        this.listSubTopic()
        this.listManagerSubTopic()
        this.listUserCheckSign()
    },
    data() {
        return {
            listMode:'list',
            managerMode:'manager',
            subTopicMode:'subtopic',
            subManagerMode:'submanager',
            signCheckMode:'signCheck',
            releaseMode:'release',
            subReleaseMode:'subRelease',
            showMode:'list',
            activeItem:'1',
            timestampDate,
            timestampToTime,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            dataList:[],
            topicId:'',
            subTopicId:'',
            subTopicList:[],
            managerSubTopicList:[],
            signList:[],
            signId:'',
            signStatus:1,

        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'topic_classify' }).then(res => {
                this.topicClassifyList = res.data.data;
            })
        },
        listTopic(){
            listUserManagerTopic().then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data;
                }else{
                    this.$message.error("请求出错")
                }

            });
        },
        listSubTopic(){
            userCheckList().then(res => {
                if (res.data.code === 1) {
                    this.subTopicList = res.data.data;
                }else{
                    this.$message.error("请求出错")
                }

            });
        },
        listManagerSubTopic(){
            userManagerList().then(res => {
                if (res.data.code === 1) {
                    this.managerSubTopicList = res.data.data;
                }else{
                    this.$message.error("请求出错")
                }

            });
        },
        listUserCheckSign(){
            userCheckSignList().then(res => {
                if (res.data.code === 1) {
                    this.signList = res.data.data;
                }else{
                    this.$message.error("请求出错")
                }

            });
        },
        viewInfo(item){
            this.showMode = "detail"
            this.infoId = item.topicId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 1);
        },
        //子组件传值
        changeActiveModel(model,activeItem){
            this.showMode = model;
            this.activeItem = activeItem;
            this.$emit('change-mode',this.showMode, 1);
            if (activeItem==='1'){
                this.listTopic()
            }
            if (activeItem==='2'){
                this.listManagerSubTopic()
            }
            if (activeItem==='3'){
                this.listSubTopic()
            }
            if (activeItem==='4'){
                this.listUserCheckSign()
            }
        },
        handleActiveChange(activeItem){
            this.activeItem = activeItem;
            if (activeItem==='1'){
                this.listTopic()
            }
            if (activeItem==='2'){
                this.listManagerSubTopic()
            }
            if (activeItem==='3'){
                this.listSubTopic()
            }
            if (activeItem==='4'){
                this.listUserCheckSign()
            }
        },
        handleManager(row){
            this.topicId = row.topicId;
            this.showMode = this.managerMode;
            this.$emit('change-mode',this.showMode);
        },
        // 子课题审核查看
        topicCheck(row){
            this.subTopicId = row.topicId;
            this.showMode = this.subTopicMode;
            this.$emit('change-mode',this.showMode);
        },
        //子课题管理
        subTopicManager(row){
            this.subTopicId = row.topicId;
            this.showMode = this.subManagerMode;
            this.$emit('change-mode',this.showMode);
        },
        signCheck(row){
            this.signId = row.signId;
            this.signStatus = row.status;
            this.showMode = this.signCheckMode;
            this.$emit('change-mode',this.showMode);
        },
        // 发布主课题
        handleRelease(row){
            this.showMode = this.releaseMode;
            this.topicId = row.topicId;
            this.$emit('change-mode',this.showMode);
        },

        // 发布子课题
        handleSubRelease(row){
            this.showMode = this.subReleaseMode;
            this.topicId = row.topicId;
            this.$emit('change-mode',this.showMode);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    //font-family: "黑体",serif;
}
.page-mode{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.model-container{
    width: 100%;
    height: 50px;
    display: flex;
    padding-left: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #0d55a4;
}
.model-item{
    width: auto;
    padding: 0 10px 0 10px;
    height: 28px;
    color: #0d55a4;
    border: 1px solid #0d55a4;
    line-height: 28px;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 11px;
    cursor: pointer;
    font-weight: bold;
}
.model-active{
    color: #fff!important;
    border: 1px solid #0d55a4!important;
    background-color: #0d55a4!important;
}


.tab-dfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.tab-dsh{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #4095e5
}
.tab-shtg{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-shjj{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #bd3124;
}

.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
</style>